<template lang="html">
</template>

<script>
/**
 * do nothing
 */
export default {
  name: 'stub'
}
</script>

<style lang="scss" scoped>
</style>
